const colors = {
  common: {
    black: '#000000',
    white: '#ffffff'
  },
  shadow: '#e6e6e6',
  grey: {
    main: '#656D78',
    smoke: '#F5F7FA',
    lighter: '#E6E9ED',
    light: '#CCD1D9',
    medium: '#AAB2BD',
    dark: '#353B48',
    darker: '#2A303D'
  },
  blueLight: {
    main: '#22A5E5',
    smoke: '#E8F6FD',
    light: '#A6DBF5',
    medium: '#63C0ED',
    dark: '#1873A0'
  },
  primary: {
    main: '#2286E6',
    smoke: '#E8F3FD',
    light: '#A6CEF5',
    medium: '#63AAED',
    dark: '#185EA1',
    hover: '#258DF2', // Figma Blue / Hover         [DO NOT REMOVE]
    darker: '#2B5C86', // Styleguide primary-darker [DO NOT REMOVE]
    lighter: '#cfe2f2', // Styleguide primary-lighter [DO NOT REMOVE]
    contrastText: '#fff'
  },
  branding: {
    dark: '#185eA1',
    main: '#2286e6',
    light: '#fbce86',
    medium: '#63aaed',
    smoke: '#e8f3fd',
    contrastText: '#fff'
  },
  hawksearch: {
    orange: '#FF7416',
    orangeHover: '#F56200'
  },
  success: {
    dark: '#008A18',
    medium: '#00C622',
    main: '#4CD763',
    light: '#B2EEBC',
    smoke: '#E5F9E8',
    contrastText: '#fff'
  },
  warning: {
    dark: '#B27500',
    medium: '#FFA700',
    main: '#FFC14C',
    light: '#FFDC99',
    smoke: '#FFF6E5',
    contrastText: '#fff'
  },
  error: {
    dark: '#AB0000',
    medium: '#F50000',
    main: '#F84C4C',
    light: '#FB9999',
    smoke: '#FEE5E5',
    contrastText: '#fff'
  },
  turquoise: {
    darker: '#288f7e',
    dark: '#34AD99',
    main: '#4FCEB9',
    light: '#9fe4d9',
    lighter: '#effaf8',
    contrastText: '#fff'
  },
  emerald: {
    darker: '#1b7943',
    dark: '#27AE60',
    main: '#2ECC71',
    light: '#7ee2a8',
    lighter: '#d1f5e0',
    contrastText: '#fff'
  },
  amethyst: {
    darker: '#5f486b',
    dark: '#836990',
    main: '#9476A3',
    light: '#c4b3cc',
    lighter: '#f3f0f5',
    contrastText: '#fff'
  },
  competitor: {
    dark: '#005A3E',
    main: '#1C8F77',
    light: '#3CD3D9'
  },
  thirdParty: {
    google: {
      main: '#0F9D58',
      light: '#29B772',
      secondary: '#4285F4',
      secondaryLight: '#5C9FFF'
    },
    facebook: {
      main: '#4267B2',
      light: '#5C81CC'
    }
  }
};

export default colors;
